import axios from 'axios';
import { createAppApi } from '@1823-partners/core';
import CLIENT_TOKEN from './beacon_app_token_ROE.json';

const api = createAppApi({
  appName: 'roe',
  clientToken: CLIENT_TOKEN,
  axios,
});

export const fetchRoeData = () => api.get('/api/data');

export const fetchCOF = (params) => api.get('/api/cof', { params });

export default api;
